import * as t from "io-ts";
import { table, TableRowT } from "../utils/pg-ts/pg-ts";
import {
    commonIdCodec,
    emailCodec,
    nullable,
    PositiveInt,
    validIsoDateStringCodec,
} from "./common";
import { raceIdCodec } from "./event";
import { athleteTable } from "./user";
import { categoriesTable } from "./category";
import { raceNumberCodec } from "./result";

// sync changes with related PG enum type
// CREATE TYPE registration_state AS ENUM ('unconfirmed', 'confirmed');
const registrationStateCodec = t.union([
    t.literal("unconfirmed"), // for
    t.literal("confirmed"),
]);
export type RegistrationState = t.TypeOf<typeof registrationStateCodec>;
export const registrationTable = table("registrations", {
    id: commonIdCodec,
    race_id: raceIdCodec,
    athlete_id: nullable(athleteTable.columns.id),
    category_id: nullable(categoriesTable.columns.id),
    club: athleteTable.columns.club, // TODO
    state: registrationStateCodec,
    created_at: validIsoDateStringCodec,
    updated_at: nullable(validIsoDateStringCodec),
    number: nullable(raceNumberCodec),
    // answers to dynamic commonString registration fields, keyed by field id
    dynamic_answers: nullable(t.record(t.string, t.string)),
});
export type RegistrationRow = TableRowT<typeof registrationTable>;

export const registrationsWithEmailRpc = table("registrations_with_email_v2", {
    ...registrationTable.columns,
    email: nullable(emailCodec),
});

// type ResultShow =

type BibUniqueness = "perRace" | "perEvent"; // can be derived from input - currently configurable for whole event

type BibEnterMethod = {
    kind: "manual";
};
// | {
//       kind: "autofill"; // TODO create bib_sequence table with row/rows according to https://stackoverflow.com/questions/9984196/postgresql-gapless-sequences
//       startFrom: PositiveInt; // default 1, but you can leave first 10 numbers for VIP racers...
//   };
// | {
//   kind: "enum"
//   enumId: TODO once enums are implemented
// }

type StartTimeMethod =
    | {
          kind: "manual";
      }
    | {
          kind: "autofill";
          start: PositiveInt; // default 1, but you can leave first 10 numbers for VIP racers...
          unique: "perRace" | "perEvent"; // can be derived from input
      };
